import { isMobile } from 'shared/responsive-helpers'

import Modal from 'shared/components/Modal'
import VehicleForm from 'shared/components/VehicleForm'

import useCountryState from 'shared/hooks/useCountryState'

import { changeVehicle } from 'dashboard-transactions/actions'
import { changeVehiclePendingSelector } from 'dashboard-transactions/selectors'
import { vehicleUpdateErrorSelector } from 'manage-guest-user-booking/selectors'

const EditVehicleModal = ({
    onClose,
    onCancelClick,
    vehicle,
    changeVehicle,
    reservationId,
    changeVehiclePending,
    updateVehicleError,
}) => {
    const INITIAL_STATE = {
        tag: vehicle.tag,
        make: vehicle.make,
        model: vehicle.model,
        color: vehicle.color,
        id: vehicle.id,
    }

    const [vehicleFormData, setVehicleFormData] = React.useState(INITIAL_STATE)
    const { countryStateComponent, selectedCountry, selectedState, setSelectedState, setSelectedCountry } =
        useCountryState()

    const submitVehicle = async () => {
        changeVehicle(reservationId, [{ ...vehicleFormData, country: selectedCountry, state: selectedState }])
    }

    React.useEffect(() => {
        if (vehicle?.state) {
            setSelectedState(vehicle.state)
        }
        if (vehicle?.country) {
            setSelectedCountry(vehicle.country)
        }
    }, [])

    return (
        <Modal
            header={<T>manage.my.booking.edit.vehicle.modal.heading</T>}
            size={isMobile() ? 'small' : 'large'}
            onClose={onClose}
            buttons={[
                {
                    label: <T>manage.my.booking.modal.cancel.btn.label</T>,
                    onClick: () => onCancelClick(),
                    btnClassName: 'brand-button--outline',
                },
                {
                    label: <T>manage.my.booking.modal.confirm.btn.label</T>,
                    onClick: () => submitVehicle(),
                    loading: changeVehiclePending,
                },
            ]}>
            <VehicleForm
                submitVehicle={submitVehicle}
                formValues={vehicleFormData}
                setFormValues={setVehicleFormData}
                isLoading={changeVehiclePending}
                error={updateVehicleError}
                countryStateComponent={countryStateComponent}
            />
        </Modal>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            changeVehiclePending: changeVehiclePendingSelector,
            updateVehicleError: vehicleUpdateErrorSelector,
        }),
        {
            changeVehicle,
        }
    )
)(EditVehicleModal)
